import contactApi from '@/api/contact';

let requestIsSent = false;

export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {
    users(state, getters, rootState) {
      return state.items
        .filter((c) => !c.isRequest)
        .map((c) => (c.author.id === rootState.auth.user?.id ? c.acceptor : c.author));
    },
  },
  mutations: {
    setItems(state, payload) { state.items = payload; },
    remove(state, payload) { state.items = state.items.filter((c) => c.id !== payload.id); },
    accept(state, payload) {
      const item = state.items.find((i) => i.id === payload.id);
      item.isRequest = false;
    },
  },
  actions: {
    fetchItems({ commit }) {
      if (requestIsSent) return;

      requestIsSent = true;

      contactApi.fetchList()
        .then((r) => { commit('setItems', r.items); })
        .finally(() => { requestIsSent = false; });
    },
    accept({ commit }, item) {
      contactApi.accept(item.id).then(() => {
        commit('accept', item);
      });
    },
    remove({ commit }, item) {
      commit('remove', item);
      contactApi.delete(item.id);
    },
  },
};
